module.exports = __webpack_public_path__ + "img/icon_close_hover.75fe678e.svg";